import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";
import * as styles from "src/styles/auth";
import { NavWrapper, NavLink, NavDelimiter } from "src/styles/auth";

const NavLinks = () => {
  return (
    <NavWrapper>
      <NavLink
        href="http://www.unifize.com/about-us"
        target="_blank"
        rel="noopener noreferrer"
      >
        {i18n.t(k.ABOUT_US)}
      </NavLink>
      <NavDelimiter />
      <NavLink href="mailto:help@unifize.com" style={styles.ContactUsNavLink}>
        {i18n.t(k.CONTACT_US)}
      </NavLink>
    </NavWrapper>
  );
};

export default NavLinks;
